import MunicipioService from './../_services/MunicipioService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'

const state = {
  loading: false,
  loadingStore: false,
  dropdownMunicipio: [],
  municipios: [],
  municipcioSelecionado: undefined,
  erros: '',

}

const getters = {
  GET_MUNICIPIOS : (state) => state.municipios,
  GET_DROPDOWN: state => state.dropdownMunicipio,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  MUNICIPIO_SELECTED : (state, { municipio }) => {
    state.municipcioSelecionado = municipio
  },

  SET_MUNICIPIOS : (state, { municipios }) => {
    state.municipios = municipios
  },

  SET_DROPDOWN : (state, municipios) => {
    state.dropdownMunicipio = municipios
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.municipcioSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : async ({commit}) => {
    commit('SET_DROPDOWN', [])
    commit('ERASE_ERROS')
    await MunicipioService.getDropDown()
    .then(response => {
      if (response.data.status) {
        var drop = []
        var obj = response.data.municipios
        Object.keys(obj).forEach(function (item) {
          var array = { value: obj[item].id, text: obj[item].nm_municipio+'/'+obj[item].cd_uf}
          drop.push(array)
        })
        commit('SET_DROPDOWN', drop)

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_MUNICIPIOS : async ({ commit }) => {
      commit('SET_MUNICIPIOS', { municipios : []})
      commit('ERASE_ERROS')
      await MunicipioService.getMunicipios()
      .then(response => {
        if (response.data.status) {
          commit('SET_MUNICIPIOS', { municipios : response.data.municipios })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  GET_MUNICIPIO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await MunicipioService.getMunicipio(id)
    .then(response => {
      if (response.data.status) {
        commit('MUNICIPIO_SELECTED', { municipio : response.data.municipio })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_MUNICIPIO : async ({ commit, dispatch }, municipio) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!municipio.id || !(municipio.id > 0)) { 
        var response = await MunicipioService.postMunicipio(municipio)
      } else {
        var response = await MunicipioService.putMunicipio(municipio.id, municipio)
      }

      if (response.data.status) {
        commit('MUNICIPIO_SELECTED', { municipio : response.data.municipio })
          await dispatch('GET_MUNICIPIOS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_MUNICIPIO : async ({ commit, dispatch }, municipio) => {
    commit('ERASE_ERROS')
    try {
      var response = await MunicipioService.deleteMunicipio(municipio.id)

      if (response.data.status) {
        await dispatch('GET_MUNICIPIOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  MUNICIPIO_SELECTED : ({dispatch, commit}, { municipio }) => {
    
    dispatch('GET_MUNICIPIO', municipio.id)
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Municipio/_store/index.js